import * as Yup from "yup";
import { TextField, TimePicker, GroupSelect, WeekdaysSelector } from "../../../../common/components/formFields";

export function formFields(t, sensorOptions) {
  return [
    {
      size: 12,
      field: (
        <GroupSelect id="sensorId" label={t("schedules.ScheduleForm.form.sensor")} options={sensorOptions} required />
      ),
    },
    {
      size: 12,
      field: <TextField id="designation" type="text" label={t("schedules.ScheduleForm.form.designation")} required />,
    },
    {
      size: 12,
      field: <TimePicker id="startTime" label={t("schedules.ScheduleForm.form.startTime")} required />,
    },
    {
      size: 12,
      field: <TextField id="duration" type="text" label={t("schedules.ScheduleForm.form.duration")} required />,
    },
    {
      size: 12,
      field: <WeekdaysSelector id="weekdays" type="text" label={t("schedules.ScheduleForm.form.weekdays")} />,
    },
  ];
}

export function formSchema(t) {
  return Yup.object().shape({
    sensorId: Yup.string().required(t("schedules.ScheduleForm.form.requiredSensor")),
    designation: Yup.string().required(t("schedules.ScheduleForm.form.requiredDesignation")),
    startTime: Yup.string().required(t("schedules.ScheduleForm.form.requiredStartTime")),
    duration: Yup.string().required(t("schedules.ScheduleForm.form.requiredDuration")),
  });
}
